import { Calculator } from 'components/calculator'
import React from 'react'
import { TotalConsumption } from 'components/totalConsumption'
import { AverageComparison } from 'components/averageComparison'
import { Histogram } from 'components/histogram'
import { CountryComparison } from 'components/countryComparison'
import { Ratios } from 'components/ratios'

export function Interactive() {
  return (
    <div id='interactive'>
      <div className='ui grey very fitted top attached infographic segment'>
        <Calculator />
      </div>

      <div className='ui very fitted bottom attached infographic segment'>
        <TotalConsumption />
        <AverageComparison />
        <Histogram />
        <CountryComparison />
        <Ratios />
      </div>
    </div>
  )
}
